module.exports = __webpack_public_path__ + "assets/img/icon11.3c21837c.png";